import React from "react";
import Modal from "react-bootstrap/Modal";
import "./employeeAlert.css";
import Button from "../ButtonComponent/Button";
import PropTypes from "prop-types";

const EmployeeAlert = ({
  showData,
  setShowData,
  successMessage,
  failedMessage,
  errorMessageData,
  handleSubmitData = () => setShowData(false),
  // handleOut,
  buttonText = "OK",
}) => {
  return (
    <div>
      <Modal show={showData} onHide={handleSubmitData} className="alertBoxModalEmp">
        <div className="contentContainerConfirmAlert empAlertData"> 
          <Modal.Header closeButton>
            <h3>Alert</h3>
            <div className="alertMessagesData">
            <Modal.Title className={successMessage && `successIcon`}>{successMessage}</Modal.Title>
            <Modal.Title className={failedMessage && 'errorIcon'}>{failedMessage}</Modal.Title>
            </div>
            <div className={errorMessageData && `errorMessageOuter`}>
            <div className="errorMessageSpace">
                    {errorMessageData}
            </div>
            </div>
          </Modal.Header>
          <Modal.Footer>
            <div className="buttonOk">
              <Button
                text={buttonText}
                onClick={handleSubmitData}
              ></Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

EmployeeAlert.proptype = {
  setShowData: PropTypes.func,
  showData: PropTypes.bool,
  title: PropTypes.string,
  successMessage: PropTypes.string,
  errorMessageData: PropTypes.string,
  failedMessage: PropTypes.string,
  buttonSubmitText: PropTypes.string,
};
export default EmployeeAlert;
